import { Injectable } from '@angular/core';
import {
  DvDatePickerLegacyElement,
  DvDynamicFormElement,
  DvNumberboxElement,
  DvTextboxElement,
} from '@devinco/ui/legacy';
import { VehicleServiceForm } from './interfaces';
import { dvNumberMaskPresets } from '@devinco/ui/dds';

@Injectable()
export class VehicleServiceTabService {
  serviceEUInspectionNextDaysValue: number | undefined;
  nextServiceDaysValue: number | undefined;

  readonly serviceElements: DvDynamicFormElement[] = [
    new DvTextboxElement({
      colspan: 12,
      key: 'ServiceComment',
      label: 'VehicleServiceGrid.ServiceComment',
    }),
  ];

  readonly serviceIntervalElements: DvDynamicFormElement[] = [
    new DvNumberboxElement({
      colspan: 6,
      key: 'ServiceIntervalDays',
      label: 'VehicleServiceGrid.ServiceIntervalDays',
    }),
    new DvNumberboxElement({
      colspan: 6,
      key: 'ServiceIntervalMileage',
      label: 'VehicleServiceGrid.ServiceIntervalKm',
    }),
    new DvNumberboxElement({
      colspan: 6,
      key: 'Mileage',
      hidden: true,
    }),
  ];

  readonly lastServiceElements: DvDynamicFormElement[] = [
    new DvDatePickerLegacyElement({
      colspan: 6,
      readonly: true,
      key: 'ServiceEUInspectionLastDate',
      label: 'VehicleServiceGrid.ServiceEUInspectionLastDate',
    }),
    new DvNumberboxElement({
      colspan: 6,
      key: 'ServiceLastMileage',
      label: 'VehicleServiceGrid.ServiceLastMileage',
    }),
    new DvDatePickerLegacyElement({
      colspan: 6,
      key: 'ServiceLastDate',
      label: 'VehicleServiceGrid.Lastservice',
    }),
  ];

  getNextServiceElements(): DvDynamicFormElement[] {
    return [
      new DvDatePickerLegacyElement({
        colspan: 6,
        disabled: true,
        key: 'NextServiceDate',
        label: 'VehicleServiceGrid.NextServiceDate',
      }),
      new DvTextboxElement({
        backgroundColor: this.setNextServiceInputFieldColor(),
        colspan: 6,
        disabled: true,
        key: 'NextServiceDays',
        label: 'VehicleServiceGrid.NextServiceDays',
      }),
      new DvNumberboxElement({
        colspan: 6,
        disabled: true,
        key: 'ServiceInMileage',
        fieldMask: dvNumberMaskPresets.NegativeFormattedNumber,
        label: 'VehicleServiceGrid.NextServiceMileage',
      }),
    ];
  }

  getMandatoryRoadWorthinessTestElements = (): DvDynamicFormElement[] => [
    new DvDatePickerLegacyElement({
      colspan: 6,
      disabled: true,
      key: 'ServiceEUInspectionNextDate',
      label: 'VehicleServiceGrid.ServiceEUInspectionNextDate',
    }),
    new DvTextboxElement({
      backgroundColor: this.setRoadWorthinessInputFieldColor(),
      colspan: 6,
      disabled: true,
      key: 'ServiceEUInspectionNextDays',
      label: 'VehicleServiceGrid.ServiceEUInspectionNextDays',
    }),
  ];

  /** Prepare Service data to match form format */
  prepareDataForForms(data: VehicleServiceForm): VehicleServiceForm {
    const lastEuDate = data.ServiceEUInspectionLastDate?.substring(0, 10);
    data.ServiceEUInspectionLastDate = lastEuDate || '';
    const nextEuDate = data.ServiceEUInspectionNextDate?.substring(0, 10);
    data.ServiceEUInspectionNextDate = nextEuDate || '';
    data.ServiceLastDate = data.ServiceLastDate?.substring(0, 10) || '';
    data.NextServiceDate =
      data.ServiceIntervalDays && data.ServiceLastDate
        ? new Date(
            new Date(data.ServiceLastDate).setDate(
              new Date(data.ServiceLastDate).getDate() +
                data.ServiceIntervalDays
            )
          )
            .toISOString()
            .split('T')[0]
        : '';
    data.NextServiceDays = data.NextServiceDate
      ? Math.floor(
          (new Date(data.NextServiceDate).getTime() -
            new Date(new Date().setHours(0, 0, 0, 0)).getTime()) /
            (1000 * 60 * 60 * 24)
        )
      : '';
    return data;
  }

  /** Prepare Service data to match database */
  prepareDataForSave(
    data: Partial<VehicleServiceForm>
  ): Partial<VehicleServiceForm> {
    data.ServiceEUInspectionLastDate = data.ServiceEUInspectionLastDate
      ? data.ServiceEUInspectionLastDate + 'T00:00:00'
      : null;
    data.ServiceLastDate = data.ServiceLastDate
      ? data.ServiceLastDate + 'T00:00:00'
      : null;
    return data;
  }

  setRoadWorthinessInputFieldColor = (): string => {
    if (
      this.serviceEUInspectionNextDaysValue === undefined ||
      this.serviceEUInspectionNextDaysValue === 0
    ) {
      return '';
    } else if (this.serviceEUInspectionNextDaysValue! < 20) {
      return 'var(--dv-bg-surface-danger-active)';
    } else if (this.serviceEUInspectionNextDaysValue! < 50) {
      return 'var(--dv-bg-surface-warning-active)';
    } else {
      return '';
    }
  };

  private setNextServiceInputFieldColor = (): string => {
    if (
      this.nextServiceDaysValue === undefined ||
      this.nextServiceDaysValue === 0
    ) {
      return '';
    } else if (this.nextServiceDaysValue! < 1) {
      return 'var(--dv-bg-surface-danger-active)';
    } else if (this.nextServiceDaysValue! < 31) {
      return 'var(--dv-bg-surface-warning-active)';
    } else {
      return '';
    }
  };
}
